/**
 * ¿Es una asamblea registrada después, que no se convocó por Habitia (por
 * ejemplo, la primera de un edificio que todavía no estaba en la plataforma)?
 * El servidor la crea finalizada con origen "registrada" y sin citaciones. Si
 * la vista no trae `origen`, se reconoce porque terminó sin haberse convocado
 * nunca: una convocada siempre tiene el resumen de sus citaciones.
 */
export const esRegistrada = (a) => !!a && (a.origen === "registrada" || (a.estado === "finalizada" && !a.resumen));

/** Fecha de hoy en Montevideo ("YYYY-MM-DD"): el máximo de la fecha de una asamblea ya realizada. */
export const hoyMontevideo = (ahora = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "America/Montevideo", year: "numeric", month: "2-digit", day: "2-digit" }).format(ahora);

/** Fecha y hora de Montevideo → ms (Uruguay es UTC−3 todo el año); NaN si no se puede leer. */
export const msDeFechaHora = (fecha, hora) => Date.parse(`${fecha}T${hora || "00:00"}:00-03:00`);
